import React from "react";
import "./CodeHideBrands.css";
import logo from "../../../assets/codehidewhitelogo.png";
import image from "../../../assets/codehidebrands.jpg";

const CodeHideBrands = () => {
  return (
    <div className="Code-Hide-Brands-1">
      <img
        src={image}
        alt="Code Hide Brands"
        className="Code-Hide-Brands-Custom-image"
      />
      <a href="https://codehide.com" target="_blank" rel="noopener noreferrer">
        <img
          src={logo}
          alt="Code Hide Logo"
          className="Code-Hide-Brands-Custom-logo"
        />
      </a>
    </div>
  );
};

export default CodeHideBrands;
